export default __webpack_public_path__ + "static/media/fusee.5e1976e2.png";